// src/pages/OpeningPage.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./OpeningPage.css";
import pitlabsLogo from "../assets/PITlogo.png";

const backgroundStyle = {
  background: "url('/background.png') center/cover no-repeat",
  minHeight: "100vh"
};

const OpeningPage = () => {
  const navigate = useNavigate();

  return (
    <div className="opening-page" style={backgroundStyle}>  {/* ✅ applied here */}
      <div className="navbar">
        <img src={pitlabsLogo} alt="PIT Labs Logo" className="logo-img" />
        <div className="nav-buttons">
          <button onClick={() => navigate("/login")} className="nav-btn">Login</button>
          <button onClick={() => navigate("/register")} className="nav-btn">Register</button>
        </div>
      </div>

      <div className="welcome-text">
        <h1>Hey there!</h1>
        <p>Welcome to PIT Labs.<br />
        Take on Real challenges, Build Real skills</p>
      </div>
      
      <div className="footer">
        <hr className="footer-line" /> 
        People  -  Internet  -  Technology
      </div>
    </div>
  );
};

export default OpeningPage;
